<p class="preview-introductory-text">
  Bitte überprüfen Sie hier noch einmal Ihre Angaben. Wenn alle Angaben stimmen können Sie das Formular absenden.
</p>

@let isTitleHidden = data.hideStepTitle;

<div class="steps">
  @for (stepPreview of preview$ | async; track stepPreview) {
    @if (!isTitleHidden && stepPreview.label) {
      <h5>{{ stepPreview.label }}</h5>
    }

    @for (fieldPreview of stepPreview.fields; track fieldPreview) {
      <div class="field full-width" [class.field-last]="$last">
        <span class="label">{{ fieldPreview.label }}</span>

        <span class="value">
          @if (fieldPreview.value; as value) {
            @for (line of value; track line) {
              {{ line }}
              @if (!$last) {
                <br>
              }
            }
          } @else {
            {{ emptyValueMessage }}
          }
        </span>
      </div>
    }

    @for (fileFieldPreview of stepPreview.files; track fileFieldPreview) {
      <div class="field full-width">
        <span class="label">{{ fileFieldPreview.label }}</span>

        <span class="value">
          @if (fileFieldPreview.value) {
            <ui-file-preview-list [editable]="false" [values]="fileFieldPreview.value"></ui-file-preview-list>
          } @else {
            {{ emptyValueMessage }}
          }

        </span>
      </div>
    }

    @for (inputListPreview of stepPreview.inputList; track inputListPreview.label) {
      @if (inputListPreview.label) {
        <h5 class="input-list-label">{{ inputListPreview.label }}</h5>
      }

      @if (isMobile$ | async) {
        @for (row of inputListPreview.rows; track $index) {
          @for (column of inputListPreview.columns; track column.name) {
            <div class="field">
              <span class="label">{{ column.label }}</span>
              <span class="value">{{ row[column.name] }}</span>
            </div>
          }
        }
      } @else {
        <table>
          <thead>
          <tr>
            @for (column of inputListPreview.columns; track column.name) {
              <th>{{ column.label }}</th>
            }
          </tr>
          </thead>
          <tbody>
            @for (row of inputListPreview.rows; track $index) {
              <tr>
                @for (column of inputListPreview.columns; track column.name) {
                  <td>{{ row[column.name] }}</td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
    }
  }
</div>
